<template>
  <div :class="showLegendAtTheTop ? 'legend-top' : 'legend'">
    <div class="legend-item">
      <div class="legend-color legend-booked">&nbsp;</div> - {{ $i18n.t('kinni') }}
    </div>
    <br>
    <div class="legend-item">
      <div class="legend-color legend-onhold">&nbsp;</div> - {{ $i18n.t('broneeritud') }}
    </div>
    <br>
    <div class="legend-item">
      <div class="legend-color legend-selected">&nbsp;</div> - {{ $i18n.t('selected_dates') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'CalendarLegend',

  props: {
    showLegendAtTheTop: {
      type: Boolean,
      default: false
    },
    showOverlay: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
